const { log } = console
const { getTargetAtClientPosition } = require('./utils/coordinates.js')
const HistoryItem = require('./utils/history-item.js')
module.exports = function store (state, emitter) {
  emitter.on('start-dragging-sprite-variable', variableId => {
    log('start-dragging-sprite-variable')
    state.draggingSpriteVariable = true
    state.selectedVariableId = variableId
    emitter.emit('render')
  })

  emitter.on('start-setting-sprite-variable', variableId => {
    log('start-setting-sprite-variable')
    state.settingSpriteVariable = true
    state.selectedVariableId = variableId
    emitter.emit('render')
  })

  emitter.on('stop-changing-variable', () => {
    log('stop-changing-variable')
    state.changingVariable = false
  })

  emitter.on('set-variable', (target, variable, value) => {
    log('set-variable', target, variable, value)
    const historyItem = HistoryItem({
      actionType: 'set-variable',
      targetId: target.id,
      variableId: variable.id,
      value: variable.value
    })

    if (!state.changingVariable) {
      emitter.emit('push-history', historyItem)
      state.changingVariable = true
    }
    state.vm.setVariableValue(target.id, variable.id, value)
    emitter.emit('render')
  })

  emitter.on('set-selected-sprite-variable', e => {
    log('set-selected-sprite-variable', e)
    const clickTarget = getTargetAtClientPosition(
      e.clientX,
      e.clientY,
      state.vm
    )
    let selectedTarget = state.vm.runtime.targets.find(
      t => t.id === state.selectedTargetId
    )
    if (!selectedTarget) {
      selectedTarget = state.vm.runtime.getTargetForStage()
    }
    const variable = selectedTarget.variables[state.selectedVariableId]
    let value = 'none'
    if (clickTarget) {
      value = clickTarget.sprite.name
    }
    emitter.emit('set-variable', selectedTarget, variable, value)
    state.settingSpriteVariable = false
    state.draggingSpriteVariable = false
    state.selectedVariableId = null
    emitter.emit('render')
  })

  emitter.on('select-variable-page', index => {
    log('select-variable-page', index)
    state.currentVariablePage = index
    emitter.emit('render')
  })
}
